import React, { useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import {
  FormRow,
  FormGroup, Label, Input, Select, Button, ButtonGroup, SectionTitle,
  Modal, ModalContent, ModalHeader, CloseButton, Divider,
} from '../../styles/PageStyles';
import ImageCropper from './ImageCropper';
import { put, post } from '../../utils/apiUtils';



const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const PERS_ENDPOINT = `${BASE_URL}/api/v1/persistence/users`;
const AUTH_ENDPOINT = `${BASE_URL}/api/v1/authentication`;


const UserDetails = ({ user, onSaveUser }) => {
  const navigate = useNavigate();
  const [userDetails, setUserDetails] = useState(user || { first_name: '', last_name: '', gender:'M', date_of_birth:new Date().toISOString(), company_cd: user.companyCd, status: "INACTIVE", address: '', phone_number: '',bio: '',profile_url: null, username: '' });
  const [uploadedFileName, setUploadedFileName] = useState('');
  const [uploadedImage, setUploadedImage] = useState(null);
  const [showProfileModal, setShowProfileModal] = useState(false);

  const updateProfile = async (profileUpdateFlag = false) => {
    if (profileUpdateFlag) {
      userDetails.profile_url = uploadedFileName;
    }
    try {
      const response = await put(`${PERS_ENDPOINT}`, userDetails, {
        withCredentials: true,
      });
      setUserDetails(response);

    } catch (error) {
      console.error('Error updating profile:', error);
      navigate('/login');
    }
  };


  const handleCropComplete = (croppedFile) => {
    console.log('Uploaded file name:', croppedFile);

  };
  const handleFileUpload = (fileName) => {
    // console.log('handleFileUpload called with:', fileName);
    setUploadedFileName(fileName);
    // console.log('uploadedFileName after setState:', fileName);
    updateProfile(true);
  };

  return (
    <div>
      <SectionTitle>
        {userDetails ? (
          <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
            Edit {userDetails.first_name} {userDetails.last_name}
          </span>
        ) : (
          <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
            Add User
          </span>
        )}
      </SectionTitle>
      <Divider />

      <FormRow>
        <FormGroup>
          <Label>First Name</Label>
          <Input type="text" value={userDetails?.first_name || ''}
            onChange={(e) => setUserDetails({ ...userDetails, first_name: e.target.value })}
          />

        </FormGroup>
        <FormGroup>
          <Label>Last Name</Label>
          <Input type="text" value={userDetails?.last_name || ''}
            onChange={(e) => setUserDetails({ ...userDetails, last_name: e.target.value })} />
        </FormGroup>
      </FormRow>
      <FormRow>
        <FormGroup>
          <Label>Gender</Label>
          <Select
            value={userDetails?.gender || ''}
            onChange={(e) => setUserDetails({ ...userDetails, gender: e.target.value })}
          >
            <option value="">Select Gender</option>
            <option value="M">Male</option>
            <option value="F">Female</option>
            <option value="Other">Other</option>
          </Select>

        </FormGroup>
        <FormGroup>
          <Label>Date of Birth</Label>
          <Input
            type="date"
            value={userDetails?.date_of_birth ? userDetails.date_of_birth.split('T')[0] : ''}
            onChange={(e) => {
              const selectedDate = e.target.value;
              const formattedDate = `${selectedDate}T00:00:00Z`;
              setUserDetails({ ...userDetails, date_of_birth: formattedDate });
            }}
          />
        </FormGroup>
      </FormRow>
      <FormRow>
        <FormGroup>
          <Label>Email Address</Label>
          <Input type="email" value={userDetails?.email || ''} onChange={(e) => setUserDetails({ ...userDetails, email: e.target.value })} />
        </FormGroup>

        <FormGroup>
          <Label>Phone</Label>
          <Input type="text" value={userDetails?.phone_number || ''} onChange={(e) => setUserDetails({ ...userDetails, phone_number: e.target.value })} />
        </FormGroup>
      </FormRow>

      <FormRow>
        <FormGroup>
          <Label>Address</Label>
          <Input type="text" value={userDetails?.address || ''} onChange={(e) => setUserDetails({ ...userDetails, address: e.target.value })} />
        </FormGroup>

      </FormRow>
      <FormGroup>
        <Label>Profile Image</Label>
        <Button
          secondary
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => setShowProfileModal(true)} // Open modal on click
        >
          Upload Profile Picture
        </Button>
        {showProfileModal && (
          <Modal>
            <ModalContent>
              <ModalHeader>
                <h3>Upload Profile Picture</h3>
                <CloseButton onClick={() => setShowProfileModal(false)}>✖</CloseButton>
              </ModalHeader>
              <Divider />
              <ImageCropper
                uploadedImage={uploadedImage}
                onCropComplete={handleCropComplete}
                onFileUpload={handleFileUpload}
              />
            </ModalContent>
          </Modal>
        )}
      </FormGroup>
      <ButtonGroup>


        <Button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Cancel
        </Button>
        <Button onClick={() => onSaveUser(userDetails)}
          primary
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Save Changes
        </Button>
      </ButtonGroup>



    </div>
  );
};

export default UserDetails;